import { useState } from 'react'
import { CurecallTextButton, EyeIcon } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { ChatbotPreviewModal } from './chatbot-preview-modal.component'

export function ChatbotPreviewButton() {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div className="c-flex c-border-l c-pl-2 c-border-grey-400">
        <CurecallTextButton
          type="button"
          iconLeft={<EyeIcon className="c-h-4 c-w-4" />}
          onClick={() => setIsOpen(true)}
          className="c-text-sm"
        >
          {t('pages.configuration.followups.chatbot.preview.button')}
        </CurecallTextButton>
      </div>
      {isOpen && <ChatbotPreviewModal onClose={() => setIsOpen(false)} />}
    </>
  )
}
